import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import { Row, Col, Form} from 'react-bootstrap'
import * as styles from './_AdviserProfileContactDetailsEditor.scss'
import * as commonStyles from '../../../common/_common.scss'
import ContactNumberInput from '../../../common/forms/ContactNumberInput'
import EmailAddressInput from '../../../common/forms/EmailAddressInput'
import { connect } from 'react-redux'
import { actions } from './adviserProfileContactDetailsEditorActions.js'
import { bindActionCreators } from 'redux'
import Spinner from '../../../common/Spinners/Spinner'
import PropTypes from 'prop-types';

class AdviserProfileContactDetailsEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,
    formIsValid: PropTypes.bool.isRequired,

    allContactNumberTypes: PropTypes.array.isRequired,
    editingContactNumbers: PropTypes.bool.isRequired,
    loadingContactNumbers: PropTypes.bool.isRequired,
    startEditingContactNumbers: PropTypes.func.isRequired,
    stopEditingContactNumbers: PropTypes.func.isRequired,
    canceleditingContactNumbers: PropTypes.func.isRequired,
    addNewContactNumber: PropTypes.func.isRequired,
    setContactNumber: PropTypes.func.isRequired,
    editingContactNumbersIndex: PropTypes.number,
    deleteContactNumber: PropTypes.func.isRequired,
    deleteContactNumberModal: PropTypes.bool.isRequired,
    cancelDeletingContactNumber: PropTypes.func.isRequired,
    deletingContactNumberIndex: PropTypes.number.isRequired,
    showDeleteContactNumberModal: PropTypes.func.isRequired,

    setPublicContactEmailAddress: PropTypes.func.isRequired,
    loadingPublicContactEmailAddress: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props)
    this.handleNewContactNumber = this.handleNewContactNumber.bind(this)
    this.handleContactNumber = this.handleContactNumber.bind(this)
    this.handlePublicContactEmailAddress = this.handlePublicContactEmailAddress.bind(this)
  }

  handleNewContactNumber (contactNumberTypes) {
    this.props.addNewContactNumber(contactNumberTypes)
  }

  handleContactNumber (validationResult, value, index) {
    this.props.setContactNumber(validationResult, value, index)
  }

  handlePublicContactEmailAddress (validationResult, value) {
    this.props.setPublicContactEmailAddress(validationResult, value)
  }

  render () {
    const profile = this.props.profile
    const contactDetails = profile.contactDetails
    const contactNumbers = contactDetails.contactNumbers
    let contactNumberType

    if (!this.props.allContactNumberTypes || this.props.allContactNumberTypes.length === 0) {
      return <Spinner />
    }

    contactNumberType = this.props.allContactNumberTypes.filter((el) => el.contactNumberType === 'Phone Number')[0]

    if (!contactNumberType) {
      contactNumberType = this.props.allContactNumberTypes[0]
    }

    if (contactNumbers.length === 0 && contactNumberType) {
      this.handleNewContactNumber(contactNumberType)
    }

    return <div className='modal-container'>
      <form className={styles['form-bottom-margin']}>
        <h4 className={styles['title']}>Contact Details</h4>
        <Row>
          <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
            <span>
              <Form.Group>
                <EmailAddressInput
                  id='public-contact-email-address'
                  label='Email address (for contact page)'
                  value={this.props.profile.contactDetails.publicContactEmailAddress === null ? '' : this.props.profile.contactDetails.publicContactEmailAddress}
                  validation={this.props.validationstate.publicContactEmailAddress}
                  setEmail={this.handlePublicContactEmailAddress}
                />
              </Form.Group>
            </span>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
            <ContactNumberInput id='contactNumber'
              value={contactNumbers[0] && contactNumbers[0].contactNumber !== null ? contactNumbers[0].contactNumber : ''}
              label='Phone Number (for contact page)'
              required
              validation={this.props.validationstate.contactNumbers}
              setNumber={(validationResult, value) => {
                this.handleContactNumber(validationResult, {
                  contactNumber: value,
                  contactNumberType: contactNumberType.contactNumberType,
                  contactNumberTypeId: contactNumberType.contactNumberTypeId
                }, 0)
              }}
            />
          </Col>
        </Row>
      </form>
    </div>
  }
}

const mapStateToProps = (state) => {
  return {
    formIsValid: state.adviserProfileEditorContainer.contactDetails.isInvalid.formIsValid,
    validationstate: state.adviserProfileEditorContainer.contactDetails.isInvalid,
    editingContactNumbers: state.adviserProfileEditorContainer.contactDetails.editingContactNumbers,
    loadingContactNumbers: state.adviserProfileEditorContainer.contactDetails.loadingContactNumbers,
    submittingContactNumbers: state.adviserProfileEditorContainer.contactDetails.submittingContactNumbers,
    deletingContactNumber: state.adviserProfileEditorContainer.contactDetails.deletingContactNumber,
    deleteContactNumberModal: state.adviserProfileEditorContainer.contactDetails.deleteContactNumberModal,
    deletingContactNumberIndex: state.adviserProfileEditorContainer.contactDetails.deletingContactNumberIndex,
    editingContactNumbersIndex: state.adviserProfileEditorContainer.contactDetails.editingIndex,
    allContactNumberTypes: state.adviserProfileEditorContainer.allContactNumberTypes,

    editingPublicContactEmailAddress: state.adviserProfileEditorContainer.contactDetails.editingPublicContactEmailAddress,
    loadingPublicContactEmailAddress: state.adviserProfileEditorContainer.contactDetails.loadingPublicContactEmailAddress,
    submittingPublicContactEmailAddress: state.adviserProfileEditorContainer.contactDetails.submittingPublicContactEmailAddress
  }
}

const mapDispatchToProps = (dispatch) => {
  const { add, set, edit, deletes } = actions
  return bindActionCreators({
    startEditingContactNumbers: edit.contactNumbers.start,
    stopEditingContactNumbers: edit.contactNumbers.stop,
    setContactNumber: set.contactNumber,
    addNewContactNumber: add.contactNumber,
    canceleditingContactNumbers: edit.contactNumbers.cancel,
    deleteContactNumber: deletes.contactNumbers.contactNumber,
    showDeleteContactNumberModal: deletes.contactNumbers.modal,
    cancelDeletingContactNumber: deletes.contactNumbers.cancel,

    setPublicContactEmailAddress: set.publicEmail
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfileContactDetailsEditor))
